/*
 * @providesModule AccountInfoModal
 */

import React from 'react';

import styles from './AccountInfoModal.style';
import {_m} from 'INTL';
import Label from 'Label';
import Optional from 'Optional';
import PushButton from 'PushButton';

import {
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';

const TEST_IDS = {
  ACCOUNT_INFO_MODAL: 'account_info_modal',
  ACCOUNT_INFO_MODAL_TITLE: 'account_info_modal_title',
  ACCOUNT_INFO_MODAL_BODY_TEXT: 'account_info_modal_body_text',
  ACCOUNT_INFO_MODAL_BODY_CONTENT: 'account_info_modal_body_content',
  ACCOUNT_INFO_MODAL_CANCEL_BUTTON: 'account_info_modal_cancel_button',
  ACCOUNT_INFO_MODAL_OK_BUTTON: 'account_info_ok_button',
};

interface Props {
  testID?: string,
  onDone?: () => void,
  onCancel?: () => void,
  okButtonTitle?: string,
  cancelButtonTitle?: string,
  hideCancelButton?: boolean,
  titleText?: string,
  titleMarginsStyle?: ViewStyle | null,
  bodyText?: string,
  bodyStyle?: ViewStyle | null,
  bodyContents?: React.ReactElement,
  fullWidthButtons?: boolean,
  buttonContainerStyle?: ViewStyle | null,
  buttonStyle?: ViewStyle | null,
}

const AccountInfoModal = (props: Props) => {
  return (
    <View style={[styles.overlayContainer, StyleSheet.absoluteFill]}>
      <View testID={props.testID} style={styles.modalContainer}>
  
        <Optional test={props.titleText}>
          <Label testID={TEST_IDS.ACCOUNT_INFO_MODAL_TITLE} style={[styles.titleMargins, props.titleMarginsStyle, styles.titleText]}>
            {props.titleText}
          </Label>
        </Optional>
  
        <Optional test={props.bodyText}>
          <Label testID={TEST_IDS.ACCOUNT_INFO_MODAL_BODY_TEXT} numberOfLines={0} style={[styles.bodyMargins, styles.bodyText, props.bodyStyle]}>
            {props.bodyText}
          </Label>
        </Optional>

        <Optional test={props.bodyContents}>
          <View testID={TEST_IDS.ACCOUNT_INFO_MODAL_BODY_CONTENT}>
            {props.bodyContents}
          </View>
        </Optional>

        <View style={[styles.buttonContainer, props.fullWidthButtons ? [styles.fullWidthButtonContainer, props.buttonContainerStyle] : {}]}>
          <Optional test={!props.hideCancelButton}>
            <PushButton onPress={props.onCancel}
                        testID={TEST_IDS.ACCOUNT_INFO_MODAL_CANCEL_BUTTON}
                        style={props.fullWidthButtons ? styles.fullWidthButtonLayout : styles.buttonLayout}
                        textStyle={styles.pushButtonText}
                        colors={['#7a8fac']}
                        title={props.cancelButtonTitle}
                        cornerRadius={styles.cornerRadius.borderRadius} />
          </Optional>
          <PushButton onPress={props.onDone}
                      testID={TEST_IDS.ACCOUNT_INFO_MODAL_OK_BUTTON}
                      style={props.fullWidthButtons ? styles.fullWidthButtonLayout : props.buttonStyle ?? styles.buttonLayout}
                      textStyle={styles.pushButtonText}
                      colors={['#4a90e2']}
                      title={props.okButtonTitle}
                      cornerRadius={styles.cornerRadius.borderRadius} />
        </View>
      </View>
    </View>
  );
};
  
AccountInfoModal.defaultProps = {
  testID: TEST_IDS.ACCOUNT_INFO_MODAL,
  okButtonTitle: _m('OK'),
  cancelButtonTitle: _m('Cancel'),
};

export default AccountInfoModal;

